export default "/_nuxt/77e393280bfcd9fedb59ff80045d64ad.svg";